export enum InsightTypeEnum {
    FEATURE = "feature",
    VERBESSERTES_FEATURE = "verbessertes_feature",
    INTERVIEW = "interview",
    BUGFIX = "bugfix",
    INFO = "info",
}
